import {
  CalendarDays, ClipboardList, FileUp, Presentation, ScrollText,
  Settings, Sparkles, UserPlus, Users, UsersRound,
} from 'lucide-react';

export const ROLES = {
  PRESIDENT: 'President',
  RUSH_CHAIR: 'Rush Chair',
  BROTHER: 'Brother',
};

const allRoles = [ROLES.PRESIDENT, ROLES.RUSH_CHAIR, ROLES.BROTHER];
const admins = [ROLES.PRESIDENT, ROLES.RUSH_CHAIR];

export const appNavigation = [
  { path: 'events', label: 'Events', icon: CalendarDays, roles: allRoles },
  { path: 'create-event', label: 'Create event', icon: UserPlus, roles: admins },
  { path: 'brotherhood', label: 'Brotherhood', icon: UsersRound, roles: [ROLES.PRESIDENT] },
  { path: 'import-brothers', label: 'Import brothers', icon: FileUp, roles: [ROLES.PRESIDENT] },
  { path: 'rushees', label: 'Rushees', icon: Users, roles: allRoles },
  { path: 'notes', label: 'Notes log', icon: ScrollText, roles: allRoles },
  { path: 'slides', label: 'Slides view', icon: Presentation, roles: allRoles },
  { path: '/wrapped', label: 'Rush Wrapped', icon: Sparkles, roles: allRoles },
  { path: 'manage-notes', label: 'Manage notes', icon: ClipboardList, roles: admins },
  { path: 'profile', label: 'Profile', icon: Settings, roles: allRoles },
];

export const navigationForRole = (role) =>
  appNavigation.filter((item) => item.roles.includes(role));

export const defaultPathForRole = (role) =>
  role === ROLES.PRESIDENT ? '/app/brotherhood' : '/app/events';
